import React from 'react';
import Tag from '@/components/school-management/Tag/Tag';
import styles from './CardData.module.scss';

type CardDataType = 'Default' | 'Alert' | 'Alert Link';

export type CardDataProps = {
  type: CardDataType;
  label: string;
  value: string | React.ReactNode;
  hint?: React.ReactNode;
  status?: 'INACTIVE' | 'ACTIVE';
  style?: React.CSSProperties;
};

const CardData = ({ type, label, value, hint, status, style }: CardDataProps) => {
  const typeClass = styles[type.toLowerCase().replace(/\s+/g, '-')];

  return (
    <div className={`${styles['card-data']} ${typeClass}`}>
      <div className={styles.row} style={style}>
        <div className={styles.label}>{label}</div>
        <div className={styles.rightContent}>
          {status && <Tag type={status} />}
          {!status &&
            (type === 'Alert' && value === '0' ? (
              <span className={styles['alert-text']}>{value}</span>
            ) : (
              <span>{value}</span>
            ))}
        </div>
      </div>
      {hint && <div className={styles.hint}>{hint}</div>}
    </div>
  );
};

export default CardData;
